import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { ShowTablePenjualanChildSaved } from "../../../components/ShowTable";
import { addDays, diffDays } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
  Pagination,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DatePicker from "react-datepicker";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const UbahPenjualan = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);

  // Data Penjualan
  const [noNotaPenjualan, setNoNotaPenjualan] = useState("");
  const [tglPenjualan, setTglPenjualan] = useState(null);
  const [userIdKasir, setUserIdKasir] = useState("");
  const [usernameKasir, setUsernameKasir] = useState("");
  const [shiftPenjualan, setShiftPenjualan] = useState("");
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Customer
  const [nopolCustomer, setNopolCustomer] = useState("");
  const [sumberCustomer, setSumberCustomer] = useState("EKSTERNAL");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [kodeMekanik, setKodeMekanik] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [kodeJenisPembayaran, setKodeJenisPembayaran] = useState("");
  const [potongan, setPotongan] = useState("0");
  const [biayaJenisPembayaran, setBiayaJenisPembayaran] = useState("0");
  const [totalBiaya, setTotalBiaya] = useState("0");
  const [total, setTotal] = useState("0");
  const [bayar, setBayar] = useState("0");
  const [kembali, setKembali] = useState("0");

  // Data Penjualan Kredit
  const [tipePenjualan, setTipePenjualan] = useState("TUNAI");
  const [lamaKredit, setLamaKredit] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState(null);

  // Data Penjualan Child
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [quantity, setQuantity] = useState("0");
  const [hargaJual, setHargaJual] = useState("0");
  const [discountPersen, setDiscountPersen] = useState("0");
  const [discount, setDiscount] = useState("0");
  const [hargaNetto, setHargaNetto] = useState("0");
  const [totalPenjualanChild, setTotalPenjualanChild] = useState("0");

  const [penjualanChilds, setPenjualanChilds] = useState([]);

  const [jenisPembayarans, setJenisPembayarans] = useState([]);
  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const tipePenjualanOption = ["TUNAI", "KREDIT"];
  let jenisPembayaranOptions = jenisPembayarans.map((jenisPembayaran) => ({
    label: `${jenisPembayaran.kodeJenisPembayaran} - ${jenisPembayaran.namaJenisPembayaran}`,
    biayaJenisPembayaran: jenisPembayaran.biayaJenisPembayaran,
  }));

  useEffect(() => {
    getPenjualanById();
    getJenisPembayarans();
  }, []);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getPenjualanById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/penjualans/${id}`, {
      kodeCabang: user.cabang.id,
      _id: user.id,
      token: user.token,
    });
    // Data Penjualan
    setNoNotaPenjualan(response.data.noNotaPenjualan);
    setTglPenjualan(new Date(response.data.tglPenjualan));
    setUserIdKasir(response.data.user.id);
    setUsernameKasir(response.data.user.username);
    setShiftPenjualan(response.data.shiftPenjualan);

    // Data Customer
    setNopolCustomer(response.data.nopolCustomer);
    setSumberCustomer(response.data.sumberCustomer);
    setNamaCustomer(response.data.namaCustomer);
    setNoTeleponCustomer(response.data.noTeleponCustomer);
    setKodeMekanik(response.data.mekanik && response.data.mekanik.namaMekanik);

    // Data Total
    setSubtotal(response.data.subtotal);
    setKodeJenisPembayaran(
      response.data.jenispembayaran &&
        `${response.data.jenispembayaran.kodeJenisPembayaran} - ${response.data.jenispembayaran.namaJenisPembayaran}`
    );
    setPotongan(response.data.potongan);
    setBiayaJenisPembayaran(response.data.biayaJenisPembayaran);
    setTotalBiaya(response.data.totalBiaya);
    setTotal(response.data.total);
    setBayar(response.data.bayar);
    setKembali(response.data.kembali);

    // Data Penjualan Kredit
    setTipePenjualan(response.data.tipePenjualan);
    setLamaKredit(response.data.lamaKredit);
    setTglJatuhTempo(
      response.data.tglJatuhTempo ? new Date(response.data.tglJatuhTempo) : null
    );

    const response2 = await axios.post(
      `${tempUrl}/penjualanChildsByPenjualan`,
      {
        penjualanId: response.data.id,
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      }
    );
    setPenjualanChilds(response2.data);
    setJumlahItem(response2.data.length);
    setLoading(false);
  };

  const getJenisPembayarans = async () => {
    const response = await axios.post(`${tempUrl}/jenisPembayarans`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setJenisPembayarans(response.data);
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
    setHargaJual(response.data.hargaJualStok);
    setHargaNetto(response.data.hargaJualStok);
    setTotalPenjualanChild(response.data.hargaJualStok);
  };

  const updatePenjualan = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/updatePenjualanTotal/${id}`, {
          tglPenjualan,
          // Total
          subtotal,
          kodeJenisPembayaran: kodeJenisPembayaran.split(" ", 1)[0],
          potongan,
          biayaJenisPembayaran,
          totalBiaya,
          total,
          bayar,
          kembali,

          // Data Penjualan Kredit
          tipePenjualan,
          lamaKredit,
          tglJatuhTempo,

          userIdUpdate: user.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate(`/daftarPenjualan/penjualan/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const savePenjualanChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen.length !== 0 &&
      discount.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPenjualanChild = await axios.post(
          `${tempUrl}/savePenjualanChild`,
          {
            // Data Penjualan Child
            penjualanId: id,
            kodeStok,
            namaStok,
            quantity,
            hargaJual,
            discountPersen,
            discount,
            hargaNetto,
            totalPenjualanChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Penjualan Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantity("");
        setHargaJual("");
        setDiscountPersen("");
        setDiscount("");
        setHargaNetto("");
        setTotalPenjualanChild("");

        let findPenjualanChild = await axios.post(
          `${tempUrl}/penjualanChildsByPenjualan`,
          {
            penjualanId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setPenjualanChilds(findPenjualanChild.data);
        setJumlahItem(findPenjualanChild.data.length);

        let findPenjualan = await axios.post(`${tempUrl}/penjualans/${id}`, {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        });
        setSubtotal(findPenjualan.data.subtotal);
        setPotongan(findPenjualan.data.potongan);
        let tempTotalBiaya =
          ((parseFloat(findPenjualan.data.subtotal) -
            parseFloat(findPenjualan.data.potongan)) *
            parseFloat(biayaJenisPembayaran)) /
          100;
        setTotalBiaya(tempTotalBiaya);
        let tempTotal =
          parseFloat(tempTotalBiaya) +
          (parseFloat(findPenjualan.data.subtotal) -
            parseFloat(findPenjualan.data.potongan));
        setTotal(tempTotal);
        let tempKembali = parseFloat(bayar) - parseFloat(tempTotal);
        setKembali(tempKembali);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Penjualan / Service</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated}>
        <Card>
          <Card.Header>Data Penjualan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noNotaPenjualan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglPenjualan}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglPenjualan(date);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kasir :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={usernameKasir}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Shift :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={shiftPenjualan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Customer</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={nopolCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Sumber :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={sumberCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={namaCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. HP :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noTeleponCustomer} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Mekanik :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeMekanik} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            // type="submit"
            onClick={() => {
              setIsInputStok(true);
              setDiscountPersen("0");
              setDiscount("0");
            }}
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={savePenjualanChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setQuantity(tempValue);

                            let tempTotalPenjualanChild =
                              parseFloat(tempValue) * parseFloat(hargaNetto);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Jual :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaJual}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc.{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;

                            let tempValue = values.formattedValue;
                            setDiscountPersen(tempValue);

                            let tempDiscount =
                              (parseFloat(hargaJual) * tempValue) / 100;
                            setDiscount(tempDiscount);

                            let temHargaNetto =
                              parseFloat(hargaJual) - parseFloat(tempDiscount);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPenjualanChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setDiscount(tempValue);

                            let tempDiscountPersen =
                              (parseFloat(tempValue) / parseFloat(hargaJual)) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen = Number(
                              tempDiscountPersen.toFixed(2)
                            );
                            setDiscountPersen(tempDiscountPersen);

                            let temHargaNetto =
                              parseFloat(hargaJual) - parseFloat(tempValue);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPenjualanChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Netto :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaNetto}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalPenjualanChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <ShowTablePenjualanChildSaved currentPosts={penjualanChilds} />
      </Box>

      <Form noValidate validated={validated} onSubmit={updatePenjualan}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Subtotal :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={subtotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Potongan :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={potongan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setPotongan(tempValue);

                            let tempTotal =
                              parseFloat(subtotal) -
                              parseFloat(tempValue) +
                              parseFloat(totalBiaya);
                            setTotal(tempTotal);

                            setBayar("0");
                            setKembali("0");
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Pembayaran <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={jenisPembayaranOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error &&
                                kodeJenisPembayaran.length === 0 &&
                                true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeJenisPembayaran(value.label);
                              setBiayaJenisPembayaran(
                                value.biayaJenisPembayaran
                              );

                              let tempTotalBiaya =
                                (parseFloat(subtotal) *
                                  parseFloat(value.biayaJenisPembayaran)) /
                                100;
                              setTotalBiaya(tempTotalBiaya);

                              let tempTotal =
                                parseFloat(subtotal) +
                                parseFloat(tempTotalBiaya);
                              setTotal(tempTotal);

                              if (value.label !== "1 - TUNAI") {
                                setBayar(tempTotal);
                              }

                              let tempKembali =
                                parseFloat(bayar) - parseFloat(tempTotal);
                              setKembali(tempKembali);
                            } else {
                              setKodeJenisPembayaran("");
                            }
                          }}
                          value={kodeJenisPembayaran}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Biaya :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalBiaya}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Bayar <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={bayar}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setBayar(tempValue);

                            let tempKembali =
                              parseFloat(tempValue) - parseFloat(total);
                            setKembali(tempKembali);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kembali :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={kembali}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe Penjualan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={tipePenjualan}
                          onChange={(e) => {
                            setTipePenjualan(e.target.value);

                            if (e.target.value === "TUNAI") {
                              setLamaKredit("");
                              setTglJatuhTempo(null);
                            }
                          }}
                        >
                          {tipePenjualanOption.map((tipePenjualan) => (
                            <option value={tipePenjualan}>
                              {tipePenjualan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kredit{" "}
                        {tipePenjualan === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={lamaKredit}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setLamaKredit(tempValue);

                            let tempTglJatuhTempo = addDays(
                              tglPenjualan,
                              parseInt(tempValue)
                            );
                            setTglJatuhTempo(tempTglJatuhTempo);
                          }}
                          disabled={tipePenjualan !== "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jatuh Tempo{" "}
                        {tipePenjualan === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={tglJatuhTempo}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglJatuhTempo(date);

                            let tempLamaKredit = diffDays(tglPenjualan, date);
                            setLamaKredit(tempLamaKredit);
                          }}
                          disabled={tipePenjualan !== "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarPenjualan")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={id === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        setHargaJual(stok.hargaJualStok);
                        setHargaNetto(stok.hargaJualStok);
                        setTotalPenjualanChild(stok.hargaJualStok);

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default UbahPenjualan;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
